import { useState } from "react";
import { TextField, IconButton } from "@mui/material";
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from "@mui/icons-material";

export default function PasswordField({
  name,
  label,
  value,
  onChange,
  ...fieldProps
}: {
  name: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  [key: string]: any;
}) {
  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <TextField
      size="small"
      variant="outlined"
      margin="normal"
      required
      fullWidth
      name={name}
      label={label}
      id={name}
      autoComplete="current-password"
      type={showPassword ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <IconButton onClick={handleTogglePasswordVisibility}>
            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </IconButton>
        ),
      }}
      value={value}
      onChange={onChange}
      {...fieldProps}
    />
  );
}
